import { useMutation } from 'react-query';
import { whatsappMessageRequest } from 'src/models/CRM';
import {postWhatsappMessage } from 'src/services/CRM/customers';

export default function useSendWhatsapp() {
  return useMutation((data: whatsappMessageRequest) => postWhatsappMessage(data), {});
}
